/**
 * @author Muhammad Fahad
 * @datetime September, 26th 2022
 * @description: This module is for adding user new group
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ControlDisabledDirectiveModule } from 'src/app/libs/ui/directives/control-disabled/control-disabled-directive.module';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { MultiUserSelectionListModule } from '../multi-user-share-access/multi-user-selection-list/multi-user-selection-list.module';
import { AccessPointBuildingsModule } from './access-point-buildings/access-point-buildings.module';
import { AddUserGroupModule } from './add-user-group/add-user-group.module';
import { AssignDeviceGroupModule } from './assign-device-group/assign-device-group.module';
import { SuccessUserGroupModule } from './success-user-group/success-user-group.module';
import { UserGroupListingModule } from './user-group-listing/user-group-listing.module';
import { UserGroupComponent } from './user-group.component';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [UserGroupComponent],
  imports: [
    CommonModule,
    SharedLayoutModule,
    WithTooltipModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    ControlDisabledDirectiveModule,
    UserGroupListingModule,
    AddUserGroupModule,
    AssignDeviceGroupModule,
    AccessPointBuildingsModule,
    SuccessUserGroupModule,
    MultiUserSelectionListModule,
    TranslateModule
  ],
  providers:[
    LocalizationService,
    TranslateModule
  ],
  exports: [UserGroupComponent],
})
export class UserGroupModule {}
